import * as React from 'react';
import { IAction } from '../merchant-interfaces';
import { merchantActionTypes } from '../action-types';
import { ON_BOARDING_ROUTES } from '../../../utils/constatns';
import { BASE_URL } from '../../../../config/environmentConfig';
import {
  convertToApplicationViewInitialValues,
  formattedApplicationViewData,
} from '../../../constants/application-view/application-view-form';
import { IApplicationViewFees, IOwners } from '../../../interfaces/merchant';
import { feeDataTypes } from '../merchant-context-variables';
import { setApplicationDocuments } from './application';
import { GET, POST, PUT } from '../../store-helper';
import { errorAlert } from '../../../components/ToastMessage';
import { sendSentryMessage } from '../../../utils/sentry-helper';

interface IFetchApplicationView {
  dispatch: React.Dispatch<IAction>,
  mid: string,
  formik: any,
  onError?: () => void,
}
export const fetchApplicationView = async ({ dispatch, mid, formik, onError }: IFetchApplicationView): Promise<void> => {
  try {
    dispatch({ type: merchantActionTypes.IS_APPLICATION_VIEW_DATA_LOADING, payload: true });

    const data = await GET({
      pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/applicant/${mid}`
    });

    if (data) {
      const convertedData = convertToApplicationViewInitialValues(data);
      formik.setValues(convertedData);
    }
    const applicationViewFees: IApplicationViewFees = {};

    if (data?.fees?.length > 0) {
      data?.fees.forEach((fee) => {
        switch (fee?.name) {
          case feeDataTypes.PERCENTAGE:
            applicationViewFees.percentage = fee?.amount / 100;
            applicationViewFees.minFeeAmount = fee?.minimumFeeAmount ? fee?.minimumFeeAmount / 100 : null;
            break;
          case feeDataTypes.FEE_AMOUNT:
            applicationViewFees.feeAmount = fee?.amount / 100;
            break;
          case feeDataTypes.CHARGEBACK:
            applicationViewFees.chargeback = fee?.amount / 100;
            break;
          case feeDataTypes.REFUND_FEE:
            applicationViewFees.refundFee = fee?.amount / 100;
            break;
          case feeDataTypes.RISK_FEE:
            applicationViewFees.riskFee = fee?.amount / 100;
            break;
        }
      });
    }
    dispatch({ type: merchantActionTypes.FETCH_APPLICATION_VIEW, payload: data || null });
    dispatch({ type: merchantActionTypes.FETCH_APPLICATION_VIEW_FEES, payload: applicationViewFees });
  } catch (e) {
    console.log('fetchApplicationView error', e.response);
    if (e.response.status !== 404) {
      dispatch({ type: merchantActionTypes.FETCH_APPLICATION_VIEW, payload: null });
    } else if (e.response.status === 404 && onError) {
      onError();
    }
  }
};

export const fetchApplicationRowData = async (mid: string): Promise<any> => {
  try {

    return await GET({
      pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/applicant/${mid}`
    });

  } catch (e) {
    console.log('fetchApplicationView error', e.response);
  }
};

interface ISetApplicationViewData {
  dispatch: React.Dispatch<IAction>,
  formik: any,
  mid: string,
  // acquisition: string[],
  fileList: any[],
  uploadedFiles?: any[],
  alreadyUploadedDocuments?: any[],
  owners: IOwners[],
  isNext: boolean,
  handleSuccess?: () => void,
}

export const setApplicationViewData = async ({
  dispatch,
  formik,
  mid,
  // acquisition,
  fileList,
  uploadedFiles,
  alreadyUploadedDocuments,
  owners,
  isNext,
  handleSuccess,
}: ISetApplicationViewData): Promise<void> => {
  try {
    dispatch({ type: merchantActionTypes.IS_SET_APPLICATION_VIEW_DATA_LOADING, payload: true });
    const params = formattedApplicationViewData(formik.values);

    ['developerContact', 'customerSupportContact'].forEach(field => {
      if (!Object.values(params[field] || {})?.some(el => el)) {
        params[field] = null;
      }
    });

    // params.productInfo.trafficAcquisition = acquisition;
    params.next = isNext;
    params.owners = owners;

    if (uploadedFiles?.length !== alreadyUploadedDocuments?.length || fileList?.length > 0) {
      await setApplicationDocuments({
        id: mid,
        fileList,
        uploadedFiles,
      });

      if (isNext) {
        const updatedData = await fetchApplicationRowData(mid);
        uploadedFiles = updatedData?.uploadedDocuments || [];
      }
    }

    if (uploadedFiles?.length) {

      params.documents = uploadedFiles;
    }

    await PUT({
      pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/applicant/${mid}`,
      body: params,
      formik,
    });

    dispatch({ type: merchantActionTypes.IS_SET_APPLICATION_VIEW_DATA_LOADING, payload: false });
    handleSuccess();
  } catch (e) {
    dispatch({ type: merchantActionTypes.IS_SET_APPLICATION_VIEW_DATA_LOADING, payload: false });
    console.log('setApplicationViewData error', e);
  }
};

interface ISetApplicationViewDataSubmit {
  dispatch: React.Dispatch<IAction>,
  id: string,
  handleSuccess: () => void,
  enableTermsAndConditions: boolean,
}

export const setApplicationViewDataSubmit = async ({ dispatch, id, handleSuccess, enableTermsAndConditions }: ISetApplicationViewDataSubmit): Promise<void> => {
  try {
    if (!enableTermsAndConditions) {
      throw new Error ('Terms and conditions are not enabled');
    }

    dispatch({ type: merchantActionTypes.IS_APPLICATION_VIEW_DATA_SUBMISSION_LOADING, payload: true });

    await POST({
      pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/applicant/${id}/submit`,
      body: { agreeToTerms: true }
    });
    handleSuccess();
    dispatch({ type: merchantActionTypes.IS_APPLICATION_VIEW_DATA_SUBMISSION_LOADING, payload: false });
  } catch (e) {
    dispatch({ type: merchantActionTypes.IS_APPLICATION_VIEW_DATA_SUBMISSION_LOADING, payload: false });
    console.log('setApplicationViewDataSubmit error:', e.response);

    if (e?.message === 'Terms and conditions are not enabled') {
      errorAlert({
        title: 'Something went wrong. Our team was informed. Please try again later.',
        duration: 0,
        closable: true
      });
      sendSentryMessage({ name: `Terms and conditions are not enabled`, context: e });
    }

  }
};
